import { render, staticRenderFns } from "./SchoolActivityList.vue?vue&type=template&id=cbab30a2"
import script from "./SchoolActivityList.vue?vue&type=script&lang=js"
export * from "./SchoolActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports